export interface IOrttoCommunicationKeyParams {
  customerID: string | undefined;
  marketCountry: string | undefined;
}

export const orttoCommunicationKeys = {
  root: (params: IOrttoCommunicationKeyParams) =>
    ['orttoCommunication', params.customerID, params.marketCountry] as const,
  emails: (params: IOrttoCommunicationKeyParams) =>
    [...orttoCommunicationKeys.root(params), 'emails'] as const,
  sms: (params: IOrttoCommunicationKeyParams) =>
    [...orttoCommunicationKeys.root(params), 'sms'] as const,
  smsBodies: (params: IOrttoCommunicationKeyParams) =>
    [...orttoCommunicationKeys.root(params), 'smsBodies'] as const,
};

export function parseOrttoCommunicationKey<
  T extends keyof typeof orttoCommunicationKeys
>(queryKey: ReturnType<(typeof orttoCommunicationKeys)[T]>) {
  const [, customerID, marketCountry] = queryKey;
  return { customerID, marketCountry };
}
